import React, { useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button } from 'semantic-ui-react';
import { Form } from 'components/form-elements/Form';
import { Text } from 'components/typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { Grid } from 'components/layout/Grid';
import { MultiSelect } from 'components/form-elements/selects/MultiSelect';
import { useGetUserIn2n } from 'services/2n/get-user';
import { useUpdateUserIn2n } from 'services/2n/update-user';
import styles from '../../styles.module.scss';
import { UserAdministrationModalContext } from '../../UserAdministrationModalContext';
import { Brikk } from '../../../../../../../Brikk';
import { FetchActivationCode } from './components/FetchActivationCode';

export const ManageService = () => {
  const { selectedUser, service, setService } = useContext(UserAdministrationModalContext);
  const userIn2n = useGetUserIn2n(selectedUser.email);
  const updateUserIn2n = useUpdateUserIn2n(userIn2n.user, selectedUser);
  const assignedGroups = userIn2n.user?.assignedGroups.map((group) => ({ value: group.id, label: group.name })) || [];
  const availableGroups = userIn2n.user?.availableGroups.map((group) => ({ value: group.id, label: group.name })) || [];
  const allGroups = [...assignedGroups, ...availableGroups];
  const intl = useIntl();

  const { control, handleSubmit /* , watch, reset */ } = useForm({
    mode: 'onSubmit',
    defaultValues: {
      groupsAndPermissions: assignedGroups,
    },
  });

  // const { fields: tags, append: appendRfIdTag, remove: removeRfidTag } = useFieldArray({
  //   control, name: 'tags',
  // });

  // const { fields: licensePlates, append: appendLicensePlate, remove: removeLicensePlate } = useFieldArray({
  //   control, name: 'licensePlates',
  // });

  const onSubmit = (data) => {
    updateUserIn2n.mutateAsync(data);
  };

  return service ? (
    <>
      <Brikk.Heading
        heading="userAdminConfigureService"
      />
      <Text
        element="h2"
        bold
        xl
        size={20}
      >
        <FormattedMessage id="serviceConfiguration" />
      </Text>
      <Text
        size={20}
      >
        {service} / {selectedUser.email}
      </Text>

      <Form
        className={styles.formContainer}
        onSubmit={handleSubmit(onSubmit)}
      >

        <div className={styles.formWrapper}>
          <Grid
            noPadding
            oneColumn
          >
            <div className={styles.form}>

              {/*TODO: Uncomment when BE is ready for integration*/}
              {/*{tags.map((field, index) => (*/}
              {/*  <div*/}
              {/*    key={field.id}*/}
              {/*  >*/}
              {/*    <LabeledElement*/}
              {/*      label={index === 0 ? 'RIFD Tags' : ''}*/}
              {/*      description={index === 0 ? 'Add one or more RFID tags IDs for this user' : ''}*/}
              {/*      descriptionPosition="top"*/}
              {/*    >*/}
              {/*      <div*/}
              {/*        className={styles.dynamicInputList}*/}
              {/*      >*/}
              {/*        <Input*/}
              {/*          placeholder={index === 0 ? 'Enter tag ID...' : ''}*/}
              {/*          id={`tags-${index}`}*/}
              {/*          type="text"*/}
              {/*        />*/}
              {/*        {tags.length > 1 && (*/}
              {/*        <DiscardIcon*/}
              {/*          size={25}*/}
              {/*          onClick={() => removeRfidTag(index)}*/}
              {/*        />*/}
              {/*        )}*/}
              {/*      </div>*/}
              {/*    </LabeledElement>*/}
              {/*  </div>*/}
              {/*))}*/}

              {/*<Button*/}
              {/*  onClick={() => appendRfIdTag({ name: '' })}*/}
              {/*  className={styles.button}*/}
              {/*>*/}
              {/*  <Text>*/}
              {/*    Add another*/}
              {/*  </Text>*/}
              {/*  <Icon*/}
              {/*    name="plus circle"*/}
              {/*  />*/}
              {/*</Button>*/}

              <FetchActivationCode />

              {/*{licensePlates.map((field, index) => (*/}
              {/*  <div*/}
              {/*    key={field.id}*/}
              {/*  >*/}
              {/*    <LabeledElement*/}
              {/*      label={index === 0 ? 'License plates' : ''}*/}
              {/*      description={index === 0 ? 'Add one or more license plates for this user' : ''}*/}
              {/*      descriptionPosition="top"*/}
              {/*    >*/}
              {/*      <div*/}
              {/*        className={styles.dynamicInputList}*/}
              {/*      >*/}
              {/*        <Input*/}
              {/*          placeholder={index === 0 ? 'ABC 123' : ''}*/}
              {/*          id={`licensePlates-${index}`}*/}
              {/*          type="text"*/}
              {/*        />*/}
              {/*        {licensePlates.length > 1 && (*/}
              {/*        <DiscardIcon*/}
              {/*          size={25}*/}
              {/*          onClick={() => removeLicensePlate(index)}*/}
              {/*        />*/}
              {/*        )}*/}
              {/*      </div>*/}
              {/*    </LabeledElement>*/}
              {/*  </div>*/}
              {/*))}*/}

              {/*<Button*/}
              {/*  onClick={() => appendLicensePlate({ name: '' })}*/}
              {/*  className={styles.button}*/}
              {/*>*/}
              {/*  <Text>*/}
              {/*    Add another*/}
              {/*  </Text>*/}
              {/*  <Icon*/}
              {/*    name="plus circle"*/}
              {/*  />*/}
              {/*</Button>*/}

              <Controller
                name="groupsAndPermissions"
                control={control}
                render={({ field }) => (
                  <MultiSelect
                    options={allGroups}
                    title={intl.formatMessage({ id: 'groupsAndPermissions' })}
                    value={field.value}
                    onChange={field.onChange}
                  />
                )}
              />
            </div>
          </Grid>
        </div>

        {/*<ManageAccessToAdditionalServices />*/}

        <div className={styles.formButtons}>
          <Button
            basic
            name="cancel-service-details"
            size="small"
            intl="cancel"
            onClick={() => {
              setService(null);
            }}
          >
            <FormattedMessage id="cancel" />
          </Button>
          <Button
            type="submit"
            name="save-changes"
            loading={updateUserIn2n?.isLoading}
          >
            <FormattedMessage id="saveChanges" />
          </Button>
        </div>
      </Form>
    </>
  ) : null;
};
